export default __webpack_public_path__ + "static/media/tripboomerang-screenshot.4daea364.png";